/**
 * * Модель удаления файла
 */
export class RemoveFileModel {
  /**ID задачи */
  TaskId!: number;
  /**ID файла */
  FileId!: number;

  constructor(obj?: Partial<RemoveFileModel>) {
    Object.assign(this, obj);
  }
}
